// @ts-nocheck
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { PagesCollectionModel } from "@insite/client-framework/Services/ContentService";

const customBlogSearchUrl = "/api/v1/custom/search/blog";

export interface GetBlogListApiParameter extends ApiParameter {
    page?: number;
    pageSize?: number;
    id: string;
    query?: string;
}
export interface GetBlogCollectionApiParameter extends ApiParameter {
    query?: string;
    page?: number;
    pageSize?: number;
}

export function getBlogSearchResults(parameter: GetBlogCollectionApiParameter) {
    return get<PagesCollectionModel>(customBlogSearchUrl, parameter);
}
